module.exports = __webpack_public_path__ + "img/12.ec1bc04b.svg";